import { render, staticRenderFns } from "./BrothersAndSisters.vue?vue&type=template&id=78589e16&scoped=true&"
import script from "./BrothersAndSisters.vue?vue&type=script&lang=js&"
export * from "./BrothersAndSisters.vue?vue&type=script&lang=js&"
import style0 from "./BrothersAndSisters.vue?vue&type=style&index=0&id=78589e16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78589e16",
  null
  
)

export default component.exports